import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import Props from './CouponComponent';
import EventSummaryContainer from "../../../containers/EventSummaryContainer";
import AlertContainer from '../../cart/containers/AlertContainer';
import KioskLayoutContainer from '../../kiosk/containers/KioskLayoutContainer';
import Translation from "../../../../shared/Translation";
import Button from 'shared/Button';

class PresaleCoupon extends Component<Props> {
    renderCouponContent = () => {
        return (
            <Fragment>
                <div className="tickets__content">
                    <div className="card">
                        <div className="text-center">
                          <p id='presale-coupon-desc'><Translation>{'checkout__presale_tickets_available_to_buyers_with_code'}</Translation></p>
                        </div>
                        <div className="input">
                            <input className="input__control" type="text"
                                placeholder="Enter presale code here"
                                value={this.props.presaleCode}
                                autoFocus
                                onChange={this.props.onPresaleCodeChange}
                            />
                        </div>
                    </div>
                    { this.props.showError && <div className="message__container message__container_error error__content">
                        <p><Translation>{'checkout__invalid_coupon_for_event'}</Translation></p>
                    </div>}
                    { this.props.showWarning && <div className="message__container message__container_warning error__content">
                        <p><Translation>{'checkout__already_applied_code'}</Translation></p>
                    </div>}
                </div>
                <div className="event-inventory__footer">
                    <div className="cart__footer-actions">
                        <Button 
                            className="button--primary button--large cart__button-checkout" 
                            disabled={!this.props.presaleCode || !!this.props.disabled}
                            onClick={this.props.onPresaleCodeSubmit}
                            loading={this.props.loading}
                        >
                            <Translation>{'checkout__submit'}</Translation>
                        </Button>
                        
                        {!!this.props.canCancel && <Button className="button--clear cart__button-back" onClick={this.props.onPresaleCodeCancel}>
                            <Translation>{'checkout__cancel'}</Translation>
                        </Button>}
                    </div>
                </div>
            </Fragment>
        );
    }

    render() {

        if (!this.props.asOverlay) {
            return this.renderCouponContent();
        }

        if (this.props.isKioskMode) {
            if (this.props.isKioskMode) {
                return (
                    <KioskLayoutContainer>
                        {this.renderCouponContent()}
                    </KioskLayoutContainer>
                );
            }
        }

        return (
            <dialog
              className="tickets--as-overlay tickets-wrap"
              aria-modal="true"
              aria-describedby="presale-coupon-desc"
            >
                {this.props.showError === false &&
                    <div className="">
                        <AlertContainer/>
                    </div>
                }
                <div className="tickets">
                    <div className="tickets__header">
                        <div className="header__right">
                            <Button onClick={this.props.onPresaleCodeCancel}  className="button--clear button--close ticket__hide-overlay"><i className="icon-close" aria-hidden="true"></i><span className="sr-only"><Translation>{'checkout__close'}</Translation></span></Button>
                        </div>
                        <EventSummaryContainer />
                    </div>
                    {this.renderCouponContent()}
                </div>
            </dialog>
        )
    }
}

PresaleCoupon.propTypes = {
    presaleCode: PropTypes.string,
    onPresaleCodeChange: PropTypes.func,
    onPresaleCodeSubmit: PropTypes.func,
    onPresaleCodeCancel: PropTypes.func,
    showError: PropTypes.bool,
    showSuccess: PropTypes.bool,
    showWarning: PropTypes.bool,
    isPresaleValid: PropTypes.bool,
    isPresaleCodeApplied: PropTypes.bool,
    asOverlay: PropTypes.bool,
    canCancel: PropTypes.bool,
    loading: PropTypes.bool,
};

PresaleCoupon.defaultProps = {
    asOverlay: true,
    canCancel: true,
    loading: false,
}

export default PresaleCoupon;
